import { forwardRef } from "react";

import { useField, useFormikContext, getIn } from "formik";
import { dissoc } from "ramda";

import { TreeSelect, TreeSelectProps } from "src/components/TreeSelect";

export interface FormikTreeSelectProps extends TreeSelectProps {
  /** Formik field name. */
  name: string;
}

const FormikTreeSelect = forwardRef<HTMLButtonElement, FormikTreeSelectProps>(
  ({ name, onChange: onChangeProp, ...otherProps }, ref) => {
    const [field, meta, { setValue }] = useField(name);
    const { status = {}, setStatus } = useFormikContext();
    const fieldStatus = getIn(status, name);

    return (
      <TreeSelect
        ref={ref}
        error={meta.error || fieldStatus || ""}
        value={field.value}
        onChange={(value: string) => {
          setStatus(dissoc(name, status));
          setValue(value);
          onChangeProp?.(value);
        }}
        {...otherProps}
      />
    );
  }
);

FormikTreeSelect.displayName = "FormikTreeSelect";

export { FormikTreeSelect };
